// @flow

/**
 * Deterministically stringify a JSON object (stable key order) and return a hash string.
 * This is sufficient for change detection; not a cryptographic hash.
 */
export const stableStringify = (obj) => {
  const seen = new WeakSet();
  const stable = (o) => {
    if (o && typeof o === 'object') {
      if (seen.has(o)) return null; // avoid cycles
      seen.add(o);
      if (Array.isArray(o)) return o.map(stable);
      const keys = Object.keys(o).sort();
      const out = {};
      keys.forEach((k) => {
        out[k] = stable(o[k]);
      });
      return out;
    }
    return o;
  };
  try {
    return JSON.stringify(stable(obj || {}));
  } catch (e) {
    return String(Math.random());
  }
};

export const hashJson = (obj) => stableStringify(obj);
